<template>
  <base-display-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners">
    <div style="min-height: 72px"
         :style="{paddingLeft:getItemHPadding,paddingRight:getItemHPadding,paddingTop:getItemVPadding,paddingBottom:getItemVPadding}"
         v-if="iteminfo.config.displayType === 2">
      <ul class="flex j-start flex-wrap" id="sss">
        <li :key="index" class="flex-s-0" style="width: 50%"
            :style="{paddingLeft:getItemHPadding,paddingRight:getItemHPadding,paddingTop:getItemVPadding,paddingBottom:getItemVPadding}"
            v-for="(item,index) in getshowDataList">
          <ratio-div :RadioValue="getCardTypeRadioValue()">
            <div class="w-full h-full absolute top-0 left-0 flex a-center o-hidden">
              <img :src="getdefaultnavImg(item)" class="w-full"
                   style="cursor: pointer"/>
            </div>
          </ratio-div>
        </li>
      </ul>
    </div>
    <div class="bg-white" style="min-height: 90px" v-if="iteminfo.config.displayType === 1">
      <ul class="flex j-start flex-wrap p-v-10 p-h-10">
        <li :key="index" class="p-4 flex-s-0" :style="{width: getWidth()}"
            v-for="(item,index) in getshowDataList">
          <!--          <ratio-div :RadioValue="100">-->
          <div class=" flex-column a-center j-center">
            <div class="w-p-60 h-p-60 flex a-center j-center o-hidden">
              <img :src="getdefaultnavImg(item)"
                   class="w-full"
                   style="cursor: pointer;height: 48px;width: 48px;border-radius: 24px"/>
            </div>
            <div class="m-t-5" style="cursor: pointer">
              {{ item.name || '导航' + (index + 1) }}
            </div>
          </div>
          <!--          </ratio-div>-->
        </li>
      </ul>
    </div>
    <div class="bg-white" style="min-height: 90px" v-if="iteminfo.config.displayType === 3">
      <Carousel class="w-full o-hidden" dots="outside" ref="carousel" v-model="value1">
        <CarouselItem :key="index" class="w-full " v-for="(item,index) in getshowDataList">
          <ratio-div :RadioValue="getRadioValue()">
            <div class="w-full h-full absolute top-0 left-0 flex-column a-center j-center o-hidden">
              <img :src="getdefaultnavImg(item)"
                   class="w-full"
                   style="cursor: pointer"/>
            </div>
          </ratio-div>
        </CarouselItem>
      </Carousel>
    </div>
  </base-display-widget>
</template>

<script>
import BaseDisplayWidget from '../base/BaseDisplayWidget'
import RatioDiv from '../../common/RatioDiv'

export default {
  name: 'NavDisplayWidget',
  components: {RatioDiv, BaseDisplayWidget},
  props: {
    iteminfo:{
      type: Object,
      default: ()=>{
        return {
          config:{
            datalist:[{},{}]
          }
        }
      }
    }
  },
  data () {
    return {
      value1: 0,
      radioValue: 40,
    }
  },
  computed: {
    getshowDataList () {
      let list = []
      list = this.getDefaultProductList()
      return list
    },
    getItemHPadding () {
      return (this.iteminfo.config.hSpacing / 2) + 'px'
    },
    getItemVPadding () {
      return (this.iteminfo.config.vSpacing / 2) + 'px'
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    getdefaultnavImg (item) {
      let src = require('../../../assets/tempmenu/img_picture_abreast.png')
      if (this.iteminfo.config.displayType === 2) {
        src = require('../../../assets/tempmenu/img_nav_card.png')
      } else if (this.iteminfo.config.displayType === 1) {
        src = require('../../../assets/tempmenu/img_nav_icon.png')
      } else if (this.iteminfo.config.displayType === 3) {
        src = require('../../../assets/tempmenu/img_carousel.png')
      }
      if (item.picurl) {
        src = item.picurl
      }
      return src
    },
    getDefaultProductList () {
      // let templist = []
      // let length = 1
      // if (this.iteminfo.config.displayType === 1) {
      //   length = 4
      // } else if (this.iteminfo.config.displayType === 2) {
      //   length = 4
      // } else if (this.iteminfo.config.displayType === 3) {
      //   length = 4
      // }
      // let len = this.iteminfo.dataList.length || 0
      // if (length <= len) {
      //   templist = this.iteminfo.dataList
      // } else {
      //   templist = templist.concat(this.iteminfo.dataList)
      //   for (let i = 0; i < (length - len); i++) {
      //     templist.push({
      //       id: 0,
      //       picurl: '',
      //       title: ''
      //     })
      //   }
      // }
      let templist = this.iteminfo.config.datalist
      return templist
    },
    //图标式宽度..
    getWidth () {
      let list = this.iteminfo.config.datalist
      if (list.length > 3) {
        return '25%'
      } else {
        return (100 / list.length).toString() + '%'
      }
    },
    getRadioValue () {
      let list = this.iteminfo.config.datalist
      let screenWidth = 375

      if (list && list.length > 0 && list[0].height > 0 && list[0].width > 0) {
        let height = (screenWidth * list[0].height) / list[0].width
        return parseInt((height / screenWidth) * 100 + '')
      }

      return 75
    },
    /**
     * 卡片式,获取第一张图片高度
     */
    getCardTypeRadioValue(){
      let radio =40
      let datalist = this.iteminfo.config.datalist
      for (let i = 0; i < datalist.length; i++) {
        let item = datalist[i]
        if (item.width && item.height && item.picurl){
          radio = item.height * 100 /item.width
          break
        }
      }
      return radio
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
